(function () {
    let isUpdating = false;

    function getWishlistCount() {
        if (window.WishListHero_SDK?.GetWishListItemsCount) {
            const sdkCount = window.WishListHero_SDK.GetWishListItemsCount();
            if (!isNaN(sdkCount)) return sdkCount;
        }

        if (window.WishlistHero?.getWishlistCount) {
            return window.WishlistHero.getWishlistCount();
        }

        try {
            const storageKeys = [
                "wishlist-hero-wishlist-items",
                "WishlistHero_wishlist",
                "WishlistHero_items",
                "wishlist-hero-items",
            ];
            for (const key of storageKeys) {
                const rawData = localStorage.getItem(key);
                if (rawData) {
                    const parsed = JSON.parse(rawData);
                    if (Array.isArray(parsed)) return parsed.length;
                    if (parsed?.items && Array.isArray(parsed.items)) return parsed.items.length;
                }
            }
        } catch (e) { }

        const modalCards = document.querySelectorAll(".MuiDialog-root .wishlist-hero-list-card");
        if (modalCards.length > 0) return modalCards.length;

        const existingBadge = document.querySelector("#wishlisthero-floating-launcher-container .MuiBadge-badge");
        if (existingBadge) {
            const parsedCount = parseInt(existingBadge.textContent.trim(), 10);
            if (!isNaN(parsedCount)) return parsedCount;
        }

        return 0;
    }

    function updateWishlistBadge() {
        if (isUpdating) return;
        isUpdating = true;

        const count = getWishlistCount();
        const badge = document.querySelector(".wishlist-badge-count");

        if (badge) {
            const hasCount = !isNaN(count) && count > 0;
            badge.textContent = hasCount ? count : "0";
            badge.style.display = hasCount ? "flex" : "none";
        }

        setTimeout(() => { isUpdating = false; }, 50);
    }

    updateWishlistBadge();

    document.addEventListener("click", (e) => {
        const isWishlistAction = e.target.closest(
            '.wishlist-hero-list-card-footer-delete, .wishlist-hero-list-card-footer-delete-all, .MuiDialog-root button, .wishlist-hero-custom-button, .product-card__wishlist, [data-wlh-id], [class*="wishlisthero"]'
        );
        if (isWishlistAction) {
            [100, 300, 700, 1500].forEach((delay) => setTimeout(updateWishlistBadge, delay));
        }
    });

    document.addEventListener("DOMContentLoaded", () => {
        updateWishlistBadge();
        const popupContainer = document.querySelector("#wishlisthero-popup-display-container");
        if (popupContainer) {
            new MutationObserver(() => updateWishlistBadge()).observe(popupContainer, {
                childList: true,
                subtree: true,
            });
        }
    });

    const wlhEvents = [
        "wishlist-hero-wishlist-items-count",
        "wishlist-hero-wishlist-items",
        "wishlist-hero-wishlist-items-from-server",
        "wishlist-hero-wishlist-updated",
        "WishlistHero:Initialized",
        "WishlistHero:Ready",
        "WishlistHero:CountUpdated",
        "WishlistHero:ItemAdded",
        "WishlistHero:ItemRemoved",
    ];

    wlhEvents.forEach((evt) => document.addEventListener(evt, updateWishlistBadge));
    [200, 600, 1200, 2500].forEach((delay) => setTimeout(updateWishlistBadge, delay));
})();